import styled from 'styled-components';
import {injectSafeBottom} from 'ui/theme';

export const Wrapper = styled.div`
  position: absolute;
  bottom: 10px;
  right: 0px;
  left: 0px;
  max-width: ${(p) => p.theme.maxContentWidth};
  margin: auto;
  padding-inline: 10px;
  ${injectSafeBottom('margin')}

  &.hidden {
    opacity: 0;
    transition: opacity 0.3s ease;
  }
`;

export const Section = styled.div`
  position: relative;

  padding: 15px;
  margin-bottom: 2px;

  background-color: ${(p) => p.theme.modalBackground};
  border-radius: 4px;
`;

export const About = styled.div`
  display: flex;
  gap: 10px;
`;

export const Authors = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 15px;
`;

export const Action = styled(Section)`
  & > *::after {
    content: '';
    display: block;
    position: absolute;
    ${(p) => p.theme.fitContainerStyle};
  }
`;

export const ErrorAction = styled.div`
  margin-block: 15px;
  text-align: center;
  font-size: 14px;
  opacity: 0.4;
`;
